/*
 * @Author: lsq
 * @Date: 2024-03-12 11:23:39
 * @LastEditTime: 2026-01-15 16:18:21
 * @LastEditors: lsq
 * @Description: dialog 组件
 * @FilePath: /sunpay-web/src/views/users/components/dialogs/index.js
 */


import customModal from "@/service/customModal.js";
import editUserModal from "./editUser";
import userDetail from "./userDetail"; //用户详情
import setConfigModal from './setConfig'
import channelConfigModal from './channelConfig'
import resetUserPasswordModal from './resetUserPassword.vue'
/**
 * @description: 用户详情
 * @param {*} item
 * @return {*}
 */
export const detailUser = ( record, config = {}) => {
  return customModal(userDetail, { record, config, })
}

/**
 * 用户新增/编辑
 */
export const editUser = ({ record, config }) => {
  return customModal(editUserModal, { record, config })
}

// 用户配置
export const setConfig = ({ record, config }) => {
  return customModal(setConfigModal, { record, config })
}

// 通道配置
export const channelConfig = ({ record, config }) => {
  return customModal(channelConfigModal, { record, config })
}

export const resetUserPassword = ({ record, config }) => {
  return customModal(resetUserPasswordModal, { record, config })
}
